import AccessibleText from "./AccessibleText";
import { trackLink } from "utils/analytics";
import {
	isInternalUrl,
	isRelativeUrl,
	triggerInterstitialByTargetOrHref,
	validateSlashAtTheEnd,
	isAriaCurrent,
} from "utils/common";
import { Link as LinkRouter } from "react-router-dom";
import { useContext } from "react";
import { Context } from "Context";

const storePrefix = "/reservations/";

const handleTriggerAnalytics = (e, analyticsLinkId) => {
	const linkId = `${analyticsLinkId}_${e.type === "click" ? "CLICK" : "HOVER"}`;

	if (analyticsLinkId) {
		trackLink({ linkId });
	}
};
const isNotValidHref = (href) => !href;
const isNotValidContent = (title, children, accessibleText) =>
	!title && children === null && !accessibleText;
const isDefaultLocale = (currentLocale, defaultLocale) =>
	currentLocale === defaultLocale;
const buildHref = ({
	href,
	store,
	basePath,
	currentLocale,
	defaultLocale,
	shouldLocalizeUrls,
}) => {
	if (isRelativeUrl(href)) {
		if (store) {
			href = `${storePrefix}${store}${href}`;
		} else if (
			!isDefaultLocale(currentLocale, defaultLocale) &&
			shouldLocalizeUrls !== false
		) {
			href = `${basePath}${href}`;
		}
	}
	return href;
};

const Link = ({
	accessibleText = "",
	analyticsLinkId = null,
	children = null,
	className = null,
	handleClick = null,
	href,
	title = "",
	tabIndex = null,
	target = "_self",
	rel = null,
	role = null,
	trackHover = false,
}) => {
	const {
		interstitials,
		setModal,
		config: {
			shouldLocalizeUrls,
			basePath,
			store,
			currentLocale,
			defaultLocale,
		},
	} = useContext(Context);
	const isInternalHref = isInternalUrl(href);

	if (isNotValidHref(href)) {
		console.error("No href present");
		return null;
	}

	if (isNotValidContent(title, children, accessibleText)) {
		console.error("No title or content present for: ", href);
		return null;
	}

	const generalProps = {
		className: className,
		tabIndex: tabIndex,
		target: target,
		role: role,
		rel: rel,
		name: analyticsLinkId ? `&lid=${analyticsLinkId}` : null,
		onClick: (e) => {
			target &&
				triggerInterstitialByTargetOrHref(
					e,
					interstitials,
					target,
					href,
					analyticsLinkId,
					setModal
				);
			handleClick && handleClick(e);
			analyticsLinkId && handleTriggerAnalytics(e, analyticsLinkId);
		},
		onMouseEnter: (e) => {
			trackHover &&
				analyticsLinkId &&
				handleTriggerAnalytics(e, analyticsLinkId);
		},
	};

	const ariaCurrent = isAriaCurrent(href) ? "page" : undefined;

	href = buildHref({
		href,
		store,
		basePath,
		currentLocale,
		defaultLocale,
		shouldLocalizeUrls,
	});

	return isInternalHref ? (
		<LinkRouter
			aria-current={ariaCurrent}
			to={validateSlashAtTheEnd(href)}
			{...generalProps}
		>
			{children || title}
			{accessibleText && <AccessibleText>{accessibleText}</AccessibleText>}
		</LinkRouter>
	) : (
		<a aria-current={ariaCurrent} href={href} {...generalProps}>
			{children || title}
			{accessibleText && <AccessibleText>{accessibleText}</AccessibleText>}
		</a>
	);
};

export default Link;
